import { Button, SvgExternalLink } from '@loomhq/lens';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import * as analytics from 'utilities/analytics';

import InstallExtensionRebrandImg from 'img/workspace-onboarding/install-chrome-extension-rebrand.png';

import DashboardOnboardingCard, {
  DashboardOnboardingSecondaryAction,
} from '../..';
import {
  dismissElementHandler,
  markEligibleElementAsCompleteForSelectedWorkspace,
} from '../../../utilities';
import { DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED } from '../../../../../../constants/events';
import { CHROME_EXT_WEBSTORE_URL } from '../../../../../../constants/routes';
import { useExtensionInstalled } from '../../../../../../hooks/devices';
import { useGetSelectedWorkspace } from '../../../../../../hooks/workspace';
import { INSTALL_CHROME_EXTENSION_CARD_KEY } from '../../../../../../../../shared/constants/workspaceOnboarding';

const SUPPORT_ARTICLE_LINK =
  'https://support.loom.com/hc/en-us/articles/360002177497-Install-the-Chrome-Extension';

const InstallChromeExtensionCard = () => {
  const dispatch = useDispatch();
  const isExtensionInstalled = useExtensionInstalled();
  const currentWorkspace = useGetSelectedWorkspace();

  const wasLoomUserBeforeWorkspace =
    currentWorkspace?.was_loom_user_before_membership;

  useEffect(() => {
    if (!isExtensionInstalled || Object.keys(currentWorkspace).length === 0) {
      return;
    }

    if (!wasLoomUserBeforeWorkspace) {
      markEligibleElementAsCompleteForSelectedWorkspace(
        dispatch,
        [currentWorkspace],
        INSTALL_CHROME_EXTENSION_CARD_KEY
      );
    } else {
      dismissElementHandler(
        dispatch,
        INSTALL_CHROME_EXTENSION_CARD_KEY,
        currentWorkspace.id
      );
    }
  }, [
    dispatch,
    currentWorkspace,
    isExtensionInstalled,
    wasLoomUserBeforeWorkspace,
  ]);

  const header = 'Install the Chrome extension';
  const description = 'Launch Loom from your Chrome browser.';

  const primaryAction = (
    <Button
      variant="primary"
      href={CHROME_EXT_WEBSTORE_URL}
      htmlTag={'a'}
      target="_blank"
      icon={<SvgExternalLink />}
      onClick={() => {
        analytics.track(DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED, {
          type: 'primary',
          card: INSTALL_CHROME_EXTENSION_CARD_KEY,
        });
      }}
    >
      Install extension
    </Button>
  );
  const secondaryAction = (
    <DashboardOnboardingSecondaryAction
      icon={<SvgExternalLink />}
      onClick={() => {
        analytics.track(DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED, {
          type: 'secondary',
          card: INSTALL_CHROME_EXTENSION_CARD_KEY,
        });

        window.open(SUPPORT_ARTICLE_LINK);
      }}
    >
      Learn more
    </DashboardOnboardingSecondaryAction>
  );

  return (
    <DashboardOnboardingCard
      cardKey={INSTALL_CHROME_EXTENSION_CARD_KEY}
      heading={header}
      description={description}
      centerpiece={<img src={InstallExtensionRebrandImg} />}
      primaryAction={primaryAction}
      secondaryAction={secondaryAction}
      completeMessage="You have installed the Loom Chrome Extension."
    />
  );
};

export default InstallChromeExtensionCard;
